import { Box, Typography, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import moment from "moment";

function SearchDetailCategoryManager({ clickSearch, setSearchData, searchData, selectedCategory }) {
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSearchData((prev) => ({ ...prev, name: e.target.value }));
  };
  const handleAddClick = () => {
    navigate("/Category/detail/add", {
      state: { selectedCategory },
    });
  };
  return (
    <Box sx={{ mb: 3 }}>
      {/* Tiêu đề */}
      <Typography fontWeight="bold" fontSize="24px">
        CHI TIẾT DANH MỤC
      </Typography>
      <Box sx={{ mb: 1, display: "flex", alignItems: "center" }}>
        <Typography fontWeight="bold" fontSize="16px" mr={2}>
          Tên danh mục:
        </Typography>
        <Typography fontSize="16px">{selectedCategory?.categoryName || "Không rõ"}</Typography>
      </Box>

      <Box sx={{ mb: 1, display: "flex", alignItems: "center" }}>
        <Typography fontWeight="bold" fontSize="16px" mr={2}>
          Ngày cập nhật:
        </Typography>
        <Typography fontSize="16px">
          {moment(selectedCategory?.createTime).format("DD/MM/YYYY") || "Không rõ"}
        </Typography>
      </Box>

      {/* Nút Thêm mới */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between", // đẩy ra hai bên
          alignItems: "center",
          mt: 6,
          mb: 2,
        }}
      >
        <Typography fontWeight="bold" fontSize="24px">
          DANH SÁCH SẢN PHẨM
        </Typography>
        <Button
          variant="contained"
          onClick={handleAddClick}
          sx={{ backgroundColor: "#007bff", textTransform: "none" }}
          startIcon={<AddIcon />}
        >
          Thêm mới
        </Button>
      </Box>

      {/* Tìm kiếm + Filter + Sort */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          placeholder="Tìm kiếm"
          size="small"
          variant="outlined"
          value={searchData.name || ""}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && clickSearch()}
          InputProps={{
            sx: {
              backgroundColor: "#f1f7ff",
              borderRadius: "8px",
              width: "250px",
              height: "45px !important",
              "& fieldset": { border: "none" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={clickSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<FilterListIcon />}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<SortIcon />}
          >
            Sort
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

SearchDetailCategoryManager.propTypes = {
  clickSearch: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
  searchData: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  selectedCategory: PropTypes.shape({
    id: PropTypes.number,
    categoryName: PropTypes.string,
    createTime: PropTypes.string,
  }),
};

SearchDetailCategoryManager.defaultProps = {
  selectedCategory: null,
};
export default SearchDetailCategoryManager;
